import { Box, Button, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import backgroundImage from '../../../images/getStartedBg.png'

const ReadyToGetStartedSection: React.FC = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <Box
      mb={{ xs: '4rem', md: '8.75rem' }}
      display='flex'
      alignItems={'center'}
      justifyContent={'center'}
      sx={{ maxWidth: '100rem', margin: '0 auto' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          overflow: 'hidden',
          [theme.breakpoints.down(1100)]: {
            margin: '0.313rem',
          },
        }}
        mt='4.375rem'
        color='white'
        width={{ sm: '81%', xs: '100%' }}
        maxWidth='75.063rem'
        height='17.5rem'
        paddingX={{ sm: '7.5rem', xs: '0rem' }}
        borderRadius='1rem'
      >
        <Typography
          variant='h4'
          fontWeight={700}
          mt='2.063rem'
          fontSize={{ xs: '1.5rem', md: '2.5rem' }}
          sx={{
            [theme.breakpoints.down(1100)]: {
              fontSize: '1.5rem',
            },
          }}
        >
          {t('featuresPage.readyToGetStartedTitle')}
        </Typography>
        <Typography
          fontSize='1rem'
          fontWeight={300}
          maxWidth={{ xs: '100%', md: '25rem' }}
          lineHeight='1.5'
          mt='0.438rem'
          sx={{
            wordBreak: 'break-word',
            [theme.breakpoints.between(1266, 1370)]: {
              width: '26rem',
            },
          }}
        >
          {t('featuresPage.readyToGetStartedTxt')}
        </Typography>
        <Box mt={{ xs: 5, md: '2.563rem' }}>
          <Button
            sx={{
              backgroundColor: 'white',
              width: '13.688rem',
              height: '2.75rem',
              boxShadow: 'none',
              color: theme.palette.primary.main,
              fontSize: '1rem',
              fontWeight: '600',

              '&:hover': {
                backgroundColor: 'white',
                boxShadow: '0rem 0.25rem 0.375rem rgba(0, 0, 0, 0.1)',
              },
            }}
            variant='contained'
            onClick={() => navigate('/login')}
            aria-label={t('featuresPage.startFreeTrialButton')}
          >
            {t('featuresPage.startFreeTrialButton')}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default ReadyToGetStartedSection
